import { type ReactElement } from "react"

import { FileIconTemplate } from "./FileIconTemplate"

interface FileIconProps {
  className?: string
}

export const FileIcon = ({ className }: FileIconProps): ReactElement => (
  <FileIconTemplate
    className={className}
    text='FILE'
    stripeColor='#9E9E9E' // Gray
  />
)
